import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { UserService } from '../../../providers/user.service';
import { UserListComponent } from '../user-list/user-list.component';

@Component({
  selector: 'app-adsl-userlist',
  templateUrl: '../../shared/base-list/base-list.component.html',
  styleUrls: ['./adsl-userlist.component.scss', '../../shared/base-list/base-list.component.scss']
})

export class AdslUserlistComponent extends UserListComponent implements OnInit {

  constructor(
    public cookieService: CookieService,
    public activeModal: NgbModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: UserService,
    public route: ActivatedRoute,
    public router: Router
  ) {
    super(cookieService, activeModal, titleService, translator, service, route, router);
    this.subentity = 'adsl';
  }

  getBody() {
    const body = super.getBody();
    const query = ['service_type', '=', this.subentity.toUpperCase()];
    if (body.query) {
      body.query = [body.query, 'and', query];
    } else {
      body.query = query;
    }
    return body;
  }

}
